module.exports = __webpack_public_path__ + "img/shareholder-structure.c3b00e32.jpg";